export const locations = [
  {
    name: "TRIVANDRUM",
    address: "Mathrubhumi Buildings, Vanchiyoor, Thiruvanathapuram 695035",
    off: "0471 2520600",
    whatsapp: "917510555943",
    lat: 8.495904435862748,
    lng: 76.94253099608873
  },
  {
    name: "ALAPPUZHA",
    address:
      "Mathrubhumi V.M. Nair Memorial Building, Church Road, V.M. Nair Memorial Building Alappuzha, Alappuzha 688011",
    off: "0477 2230864",
    whatsapp: "91906 105 1048",
    lat: 9.459698842479087,
    lng: 76.34134672990467
  },
  {
    name: "KOZHIKODE",
    address:
      "CLUB FM 104.8, 4th Floor, MM Press Cherootty Road, Kozhikode 673001",
    off: "0495 2779444",
    whatsapp: "919061031048",
    lat: 11.25263801817407,
    lng: 75.77647633658613
  },
  {
    name: "KANNUR",
    address:
      "CLUB FM 94.3, 4th floor, Mathrubhumi Building Nadal Bypass, Edakkad PO, Kannur 670663",
    off: "0497 2825330",
    whatsapp: "917510666943",
    lat: 11.885305089214135,
    lng: 75.41088567819524
  },
  {
    name: "THRISSUR",
    address:
      "Mathrubhumi Buildings, 2nd Floor, Mathrubhumi, Veliyannur Road Thrissur, 680021",
    off: "0487 2455300",
    whatsapp: "917510551048",
    lat: 10.518507406331873,
    lng: 76.21207470959517
  },
  {
    name: "COCHIN",
    address:
      "Mathrubhumi Press, Udyogamandal Manjummel North Janatha Road, Cochin 683501",
    off: "0484 2884200",
    whatsapp: "7034943943",
    lat: 10.06384605517545,
    lng: 76.30077478260715
  },
];
